import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { Row } from 'react-bootstrap';
import { get, keyBy } from 'lodash';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicTextArea from '../../../../../shared/components/formComponents/groups/BasicTextArea';

import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import { SECTION_ITEM_TYPES } from '../../../../../shared/Constants';

class ShowPreviousAnswersFieldArray extends PureComponent {
    static propTypes = {
        fields: PropTypes.any,
        chooseOneQuestionDataSource: PropTypes.array,
        chooseManyQuestionDataSource: PropTypes.array,
        likertQuestionDataSource: PropTypes.array,
        shortEssayQuestionDataSource: PropTypes.array,
        showPreviousAndChooseDataSource: PropTypes.array,
        contentValues: PropTypes.object,
        contentValuesKey: PropTypes.string,
        disabled: PropTypes.bool
    };

    static QUESTION_TYPES = [
        {
            label: 'Choose One',
            value: SECTION_ITEM_TYPES.CHOOSE_ONE_CONTENT
        },
        {
            label: 'Choose Many',
            value: SECTION_ITEM_TYPES.CHOOSE_MANY_CONTENT
        },
        {
            label: 'Likert',
            value: SECTION_ITEM_TYPES.LIKERT_CONTENT
        },
        {
            label: 'Short Essay',
            value: SECTION_ITEM_TYPES.SHORT_ESSAY_CONTENT
        },
        {
            label: 'Show Previous Answers and Choose One',
            value: SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE
        }
    ];

    _pushField = () => {
        const { fields } = this.props;

        fields.push({
            id: uuid()
        });
    };

    _removeField = (index) => {
        const { fields } = this.props;

        fields.remove(index);
    };

    _moveUp = (index) => {
        const { fields } = this.props;

        if (index) {
            fields.swap(index, index - 1);
        }
    };

    _moveDown = (index) => {
        const { fields } = this.props;

        if (index < fields.length - 1) {
            fields.swap(index, index + 1);
        }
    };

    _getQuestionDataSource = (questionType) => {
        if (questionType === SECTION_ITEM_TYPES.LIKERT_CONTENT) {
            return this.props.likertQuestionDataSource;
        }
        if (questionType === SECTION_ITEM_TYPES.CHOOSE_ONE_CONTENT) {
            return this.props.chooseOneQuestionDataSource;
        }
        if (questionType === SECTION_ITEM_TYPES.CHOOSE_MANY_CONTENT) {
            return this.props.chooseManyQuestionDataSource;
        }
        if (questionType === SECTION_ITEM_TYPES.SHORT_ESSAY_CONTENT) {
            return this.props.shortEssayQuestionDataSource;
        }
        if (questionType === SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE) {
            return this.props.showPreviousAndChooseDataSource;
        }
        return [];
    };

    render() {
        const { fields, contentValues, contentValuesKey, disabled } = this.props;

        const fieldsArray = fields.map((name, index) => (
            <div className={'col-12'} key={contentValues[contentValuesKey][index].id}>
                <h5 className={'block-heading question'}>{`QUESTION ${index + 1}`}</h5>
                <div className={'row'}>
                    <div className={'col-10'}>
                        <div className={'row'}>
                            <Field
                                name={`${name}.questionType`}
                                label={'Question Type'}
                                className={'col-4'}
                                placeholder={'Select a Question Type'}
                                options={ShowPreviousAnswersFieldArray.QUESTION_TYPES}
                                valueKey={'value'}
                                labelKey={'label'}
                                disabled={disabled}
                                component={BasicSelect}
                            />
                            <Field
                                name={`${name}.questionId`}
                                label={'Question'}
                                className={'col-8'}
                                placeholder={'Select a Question'}
                                options={this._getQuestionDataSource(
                                    contentValues[contentValuesKey][index].questionType
                                )}
                                valueKey={'id'}
                                labelKey={'name'}
                                optionRenderer={(item) => `${item.name} [active:${item.isActive}]`}
                                disabled={disabled}
                                component={BasicSelect}
                            />
                        </div>
                    </div>
                    <div className={'col-2'}>
                        <Row className={'showPreviousAnswersSectionItem-bottomSpacer'}>
                            <VerbButton
                                fontAwesomeIcon={'fa-angle-up'}
                                buttonType={'icon-only'}
                                onClick={() => this._moveUp(index)}
                            />
                        </Row>
                        <Row className={'showPreviousAnswersSectionItem-bottomSpacer'}>
                            <VerbButton
                                fontAwesomeIcon={'fa-trash'}
                                buttonType={'icon-only'}
                                onClick={() => this._removeField(index)}
                            />
                        </Row>
                        <Row>
                            <VerbButton
                                fontAwesomeIcon={'fa-angle-down'}
                                buttonType={'icon-only'}
                                onClick={() => this._moveDown(index)}
                            />
                        </Row>
                    </div>
                </div>
            </div>
        ));
        return (
            <div className={'col-12'}>
                {fieldsArray}
                <div className={'row'}>
                    {!disabled ? (
                        <VerbButton
                            onClick={this._pushField}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            className={'spa-add-btn'}
                            fontAwesomeIcon={'fa-plus'}
                        />
                    ) : null}
                </div>
            </div>
        );
    }
}

class ShowPreviousAnswersSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        contentValues: PropTypes.object,
        chooseOneQuestionDataSource: PropTypes.array,
        chooseManyQuestionDataSource: PropTypes.array,
        likertQuestionDataSource: PropTypes.array,
        shortEssayQuestionDataSource: PropTypes.array,
        showPreviousAndChooseDataSource: PropTypes.array,
        currentSectionItemFormValues: PropTypes.object,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    _calculatePreviousLikertsTotalPossibleScore = () => {
        const { currentSectionItemFormValues, likertQuestionDataSource } = this.props;
        let totalScore = 0;
        const associatedLikerts = get(currentSectionItemFormValues, 'content.questionsToDisplay', []).filter(
            (question) => question.questionType === 'LIKERT'
        );

        const associatedLikertsById = keyBy(associatedLikerts, 'questionId');
        (likertQuestionDataSource || []).forEach((likert) => {
            if (associatedLikertsById[likert.id]) {
                totalScore += likert.content.length;
            }
        });
        return totalScore;
    };

    _createLikertsBenchmarkDropdownOptions = () => {
        const highestScore = this._calculatePreviousLikertsTotalPossibleScore();

        const dropdownOptions = [];

        for (let i = 1; i <= highestScore; i += 1) {
            dropdownOptions.push({ value: i, label: `${i}` });
        }

        return dropdownOptions;
    };

    render() {
        const {
            memberReference,
            contentValues,
            likertQuestionDataSource,
            chooseManyQuestionDataSource,
            chooseOneQuestionDataSource,
            shortEssayQuestionDataSource,
            showPreviousAndChooseDataSource,
            isGlobalSectionItem,
            currentSectionItemFormValues
        } = this.props;

        const shouldRenderLikertAgregationSection = get(
            currentSectionItemFormValues,
            'content.aggregateLikertResults.isActive',
            false
        );

        return (
            <div className={'showPreviousAnswersSectionItem col-12'}>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                        label={'Description'}
                        className={'col-12'}
                        placeholder={'Enter a description'}
                        component={VerbRichTextEditor}
                        readOnly={isGlobalSectionItem}
                        rows={3}
                    />
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <FieldArray
                        name={
                            memberReference
                                ? `${memberReference}.content.questionsToDisplay`
                                : 'content.questionsToDisplay'
                        }
                        contentValues={contentValues}
                        contentValuesKey={'questionsToDisplay'}
                        likertQuestionDataSource={likertQuestionDataSource}
                        chooseManyQuestionDataSource={chooseManyQuestionDataSource}
                        chooseOneQuestionDataSource={chooseOneQuestionDataSource}
                        shortEssayQuestionDataSource={shortEssayQuestionDataSource}
                        showPreviousAndChooseDataSource={showPreviousAndChooseDataSource}
                        component={ShowPreviousAnswersFieldArray}
                        disabled={isGlobalSectionItem}
                    />
                </div>
                <br />
                <div className={'row'}>
                    <Field
                        name={`${memberReference}.content.aggregateLikertResults.isActive`}
                        className={'col-sm-6'}
                        label={'Aggregate likert results?'}
                        component={BasicToggle}
                        defaultValue={false}
                        id={'show-prev-answers-aggregate-likert-results-toggle'}
                    />
                    {shouldRenderLikertAgregationSection && (
                        <div className={'col-sm-6'}>
                            {`TOTAL POSSIBLE SCORE: ${this._calculatePreviousLikertsTotalPossibleScore()}`}
                        </div>
                    )}
                </div>
                {shouldRenderLikertAgregationSection && (
                    <div className={'row'}>
                        <div className={'col-sm-2'}>
                            <Field
                                name={`${memberReference}.content.aggregateLikertResults.benchmark`}
                                label={'Enter expected score'}
                                placeholder={'Select benchmark'}
                                valueKey={'value'}
                                labelKey={'label'}
                                options={this._createLikertsBenchmarkDropdownOptions()}
                                component={BasicSelect}
                            />
                        </div>
                        <div className={'col-sm-10'}>
                            <Field
                                component={BasicText}
                                label={'Title'}
                                placeholder={'Enter a title'}
                                name={`${memberReference}.content.aggregateLikertResults.title`}
                            />
                            <Field
                                name={`${memberReference}.content.aggregateLikertResults.description`}
                                label={'DESCRIPTION'}
                                placeholder={'Enter a description'}
                                component={BasicTextArea}
                                rows={3}
                                maxLength={'200'}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export { ShowPreviousAnswersFieldArray };
export default ShowPreviousAnswersSectionItem;
